import type { InternalAuditResultCount } from '@risksmart-app/trpc/src/types';
import type { GetInternalAuditReportResultCountQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetInternalAuditReportResultCountDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

export const useGetInternalAuditReportResultCount = createQueryHook<
  Record<string, never>,
  InternalAuditResultCount,
  GetInternalAuditReportResultCountQuery
>({
  trpcQueryOptions: (trpc) =>
    trpc.frontend.assessment.internalAuditResultCount.queryOptions(),
  // Map each per-table count back onto its GraphQL aggregate root. ConnectedCount
  // sums the four; the factory surfaces undefined while loading, so genuine
  // zeros are preserved (no `?? 0` masking).
  mapTrpcDataToGraphQL: (data) => ({
    risk_controlled_internal_audit_result_aggregate: {
      aggregate: { count: data.risk_controlled_internal_audit_result },
    },
    risk_uncontrolled_internal_audit_result_aggregate: {
      aggregate: { count: data.risk_uncontrolled_internal_audit_result },
    },
    document_internal_audit_result_aggregate: {
      aggregate: { count: data.document_internal_audit_result },
    },
    obligation_internal_audit_result_aggregate: {
      aggregate: { count: data.obligation_internal_audit_result },
    },
  }),
  graphqlDocument: GetInternalAuditReportResultCountDocument,
});
